// extracted by mini-css-extract-plugin
export default {"page":"AdminListUser_page__uBLXd","confirmContainer":"AdminListUser_confirmContainer__yyNTd","cardContainer":"AdminListUser_cardContainer__Tpgor"};